import { Form, Input } from "reactstrap";
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { toast } from 'react-toastify';


import Modal from "../Modal";
import { AppContext } from "../../store/AppContext";
import { getSignedUrlForUpload, uploadVideoToS3, saveMetaData, getSignedUrlForThumbnail, getSignedUrlForAttachment } from "../../Services";

import "./addNewRecord.scss";

const AddNewRecord = (props) => {
  const [title, setTitle] = useState("");
  const [uploadedFile, setFile] = useState('');
  const [fileName, setFileName] = useState('');
  const [isSearch, setSearchStatus] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [description, setDescription] = useState("");
  const [isModalOpen, setModalStatus] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [videoPreview, setVideoPreview] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailName, setThumbnailName] = useState('');
  const [uploadInprogress, setProgress] = useState(false);
  const [researchId, setResearchId] = useState('');
  // Optional image attached alongside the video. Kept separate from the video
  // state so it can never satisfy or block the thumbnail snapshot gate.
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [attachmentName, setAttachmentName] = useState('');
  const [attachmentPreview, setAttachmentPreview] = useState(null);
  const { categories } = useContext(AppContext);

  const [selectedCategory, setCategory] = useState(categories[0] || '');

  const onChange = (value, updatedField) => {
    updatedField(value);
  };

  const isTitleValid = title.trim().length >= 5;

  const isDescriptionValid = description.trim().length >= 5;


  const handleFileSelection = (e) => {
    const reader = new FileReader();
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      reader.readAsDataURL(selectedFile);
    }

    reader.onload = (renderEvent) => {
      setVideoPreview(renderEvent.target.result)
    }

    let fileName = e.target.value.split('\\');
    let length = fileName.length;
    fileName = length > 0 ? fileName[length - 1] : fileName[0];
    fileName = fileName.length > 20 ? fileName.slice(fileName.length - 21, fileName.length) : fileName;
    setFileName(fileName);
    setFile(e.target.files[0]);
    setShowVideo(true);
  };

  // Optional attachment. Deliberately does not touch the video/thumbnail state -
  // submitting without one must stay possible.
  const handleAttachmentSelection = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      return;
    }

    const reader = new FileReader();
    reader.onload = (renderEvent) => setAttachmentPreview(renderEvent.target.result);
    reader.readAsDataURL(selectedFile);

    // Backend caps the name at 30 chars; keep the extension intact
    const rawName = selectedFile.name;
    const extension = rawName.slice(rawName.lastIndexOf('.'));
    const base = rawName.slice(0, rawName.lastIndexOf('.'));
    const maxBase = 30 - extension.length;
    setAttachmentName(`${base.length > maxBase ? base.slice(0, maxBase) : base}${extension}`);
    setAttachmentFile(selectedFile);
  };

  const clearAttachment = () => {
    setAttachmentFile(null);
    setAttachmentName('');
    setAttachmentPreview(null);
    const input = document.getElementById('uploadAttachment');
    if (input) {
      input.value = '';
    }
  };

  const getSnapModalContent = () => {
    return <>
      <video id="my-video" src={videoPreview} type="video/mp4" controls></video>
      <div id="snapshot">
        <div className="help">Click on "Snap" button to generate a thumbnail for your uploaded record. And click on "Confirm" button to continue.</div>
      </div>
    </>
  };

  const getModalContent = () => {
    return (
      <Form className="add-new">
        <Input
          type="text"
          name="title"
          id="Tile"
          placeholder="Title"
          value={title}
          plaintext={false}
          onChange={(e) => onChange(e.target.value, setTitle)}
        />
        <Input
          type="textarea"
          name="description"
          id="Description"
          placeholder="Description"
          value={description}
          plaintext={false}
          onChange={(e) => onChange(e.target.value, setDescription)}
        />
        <Input
          placeholder="Select Category"
          name="select"
          type="select"
          onChange={(e) => onChange(e.target.value, setCategory)}
        >
          {categories.map((item) => (
            <option>{item}</option>
          ))}
        </Input>
        <Input
          type="text"
          name="researchId"
          id="researchId"
          placeholder="Research Id (Optional)"
          value={researchId}
          onChange={(e) => onChange(e.target.value, setResearchId)}
        />
        <Input
          type="file"
          name="uploadFile"
          id="uploadFile"
          accept="video/mp4" // Restrict to .mp4 files
          onChange={handleFileSelection}
        />
        <div className="attachment-field">
          <label htmlFor="uploadAttachment" className="attachment-label">
            Attach an image (Optional)
          </label>
          <Input
            type="file"
            name="uploadAttachment"
            id="uploadAttachment"
            accept="image/jpeg,image/png"
            onChange={handleAttachmentSelection}
          />
          {attachmentPreview && (
            <div className="attachment-preview">
              <img src={attachmentPreview} alt="Selected attachment preview" />
              <button type="button" className="attachment-remove" onClick={clearAttachment}>
                Remove
              </button>
            </div>
          )}
        </div>
      </Form>
    );
  };

  // Presigned S3 POSTs go straight to the bucket and can stall on network or
  // CORS faults. Without a ceiling the modal spinner never resolves.
  const S3_UPLOAD_TIMEOUT_MS = 10 * 60 * 1000;

  const buildS3FormData = (signedResponse, file) => {
    const formData = new FormData();
    const fields = signedResponse.fields || {};
    // Order and exact field set must match the presigned policy; skip gaps so
    // we never POST the literal string "undefined".
    [
      "bucket",
      "X-Amz-Algorithm",
      "X-Amz-Credential",
      "X-Amz-Date",
      "X-Amz-Security-Token",
      "key",
      "Policy",
      "X-Amz-Signature",
      "Content-Type",
      "success_action_status",
    ].forEach((fieldName) => {
      if (fields[fieldName] != null && fields[fieldName] !== "") {
        formData.append(fieldName, fields[fieldName]);
      }
    });
    // file must be last for S3 browser POST
    formData.append("file", file, file?.name || "upload.bin");
    return formData;
  };

  const describeS3Failure = (error) => {
    if (error?.code === "ECONNABORTED") {
      return "the upload timed out";
    }
    const status = error?.response?.status;
    if (!status) {
      return "the network request failed";
    }
    const body = error.response?.data;
    const text =
      typeof body === "string"
        ? body
        : body instanceof ArrayBuffer
          ? new TextDecoder().decode(body)
          : "";
    if (/EntityTooLarge/i.test(text)) {
      return "file exceeds the allowed size";
    }
    if (/PolicyConditionFailed|InvalidPolicyDocument/i.test(text)) {
      return "upload policy rejected the file (type or size)";
    }
    return `status ${status}`;
  };

  const uploadToS3 = async (signedResponse, file, label) => {
    try {
      await axios.post(signedResponse.url, buildS3FormData(signedResponse, file), {
        timeout: S3_UPLOAD_TIMEOUT_MS,
      });
    } catch (error) {
      // axios rejects on HTTP failure, so this is the only place a failed
      // upload surfaces - a bare status check here would never run
      throw new Error(`${label} upload failed (${describeS3Failure(error)})`);
    }
  };

  const onConfirm = async () => {
    if (!isTitleValid) {
      toast.error("Title must be at least 5 characters long");
      return;
    }
    if (!isDescriptionValid) {
      toast.error("Description must be at least 5 characters long");
      return;
    }
    setProgress(true);

    try {
      const signedDetails = await getSignedUrlForUpload({ name: fileName });
      if (signedDetails?.error || !signedDetails?.response) {
        throw new Error("Could not prepare the video upload. Please try again.");
      }

      const tumbnailDetails = await getSignedUrlForThumbnail({ name: thumbnailName });
      if (tumbnailDetails?.error || !tumbnailDetails?.response) {
        throw new Error("Could not prepare the thumbnail upload. Please try again.");
      }

      await uploadToS3(signedDetails.response, uploadedFile, "Video");

      const base64Response = await fetch(thumbnail);
      const blob = await base64Response.blob();
      // Force image/jpeg + .jpeg name so the presigned Content-Type policy matches
      const thumbnailFile = new File(
        [blob],
        thumbnailName || "thumbnail.jpeg",
        { type: "image/jpeg" }
      );
      if (thumbnailFile.size > 3 * 1000 * 1000) {
        throw new Error(
          "Thumbnail is too large. Snap again or use a lower-resolution clip."
        );
      }
      await uploadToS3(tumbnailDetails.response, thumbnailFile, "Thumbnail");

      // Optional third round - skipped entirely when no image was attached
      let attachmentKey = '';
      if (attachmentFile) {
        const attachmentDetails = await getSignedUrlForAttachment({
          name: attachmentName,
          contentType: attachmentFile.type
        });
        if (attachmentDetails?.error || !attachmentDetails?.response) {
          throw new Error("Could not prepare the image upload. Please try again.");
        }
        await uploadToS3(attachmentDetails.response, attachmentFile, "Image");
        attachmentKey = attachmentDetails.response.fields.key;
      }

      const savePayload = {
        videoName: title,
        videoKey: signedDetails.response.fields.key,
        imageKey: tumbnailDetails.response.fields.key,
        description: description,
        category: selectedCategory,
        ...(researchId !== '' ? { researchId: researchId } : {}),
        ...(attachmentKey ? { attachmentKey } : {})
      };

      const saved = await saveMetaData(savePayload);
      if (saved?.error) {
        throw new Error("Record upload finished but saving metadata failed. Check Admin for pending items.");
      }
      props.close();
    } catch (error) {
      console.error("Add new record failed:", error);
      toast.error(error?.message || "Upload failed. Please try again.");
    } finally {
      // Always release the spinner - a stuck spinner with no message was the
      // reported symptom here
      setProgress(false);
    }
  };

  const onClose = () => {
    setFile(null);
    setFileName('');
    setThumbnail(null);
    setThumbnailName('');
    setModalStatus(false);
    setShowVideo(false);
    setProgress(false);
    clearAttachment();
    props.close();
  };

  // Full-res snaps at quality 1.0 routinely exceed the 3MB thumbnail policy and
  // S3 returns HTTP 400 (EntityTooLarge / policy). Cap edge length + quality.
  const THUMB_MAX_EDGE = 1280;
  const THUMB_JPEG_QUALITY = 0.82;

  const snapClickHandler = () => {
    const output = document.getElementById('snapshot');
    const video = document.getElementById('my-video');
    const srcW = video?.videoWidth || 0;
    const srcH = video?.videoHeight || 0;
    if (!srcW || !srcH) {
      toast.error("Video is not ready yet. Play a moment, then Snap again.");
      return;
    }

    const scale = Math.min(1, THUMB_MAX_EDGE / Math.max(srcW, srcH));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(srcW * scale));
    canvas.height = Math.max(1, Math.round(srcH * scale));
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    const dataUrl = canvas.toDataURL('image/jpeg', THUMB_JPEG_QUALITY);
    const imgElement = new Image();
    imgElement.src = dataUrl;
    const existing = output.getElementsByTagName("img");
    if (existing.length > 0) {
      existing[0].remove();
    }
    output.appendChild(imgElement);
    setThumbnail(dataUrl);

    let name = fileName.split(".")[0];
    name = name.length > 15 ? name.slice(0, 15) : name;
    setThumbnailName(`${name}.jpeg`);
  };

  return (
    <>
      <Modal
        className="add-new-modal"
        title="Add new record"
        content={getModalContent()}
        primary="Submit"
        secondary="Cancel"
        primaryClick={onConfirm}
        secondaryClick={onClose}
        isLoading={uploadInprogress}
        onClose={onClose}
      />
      {
        showVideo && (
          <Modal
            className='snap-for-thumbnail'
            title="Take a snap for video Thumbnail"
            content={getSnapModalContent()}
            primary="Confirm"
            primaryClick={() => setShowVideo(false)}
            secondary="Snap"
            secondaryClick={snapClickHandler}
            isPrimaryButtonDisabled={!thumbnail}
            primaryButtonDisabledContent="Please take a Snap for the uploaded video, before proceeding further"
            onClose={() => setShowVideo(false)}
            onLoad={() => {
              setThumbnail(null);
              setThumbnailName('');
            }}
          />
        )
      }
    </>
  );
};

export default AddNewRecord;
